import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import type { AttendTicket } from "../../../types/models/ticket.model.type";
import type { ApproveTicketsState, FilterOptionsAttendTickets } from "../../../types/states/ticket.state.type";
import { DEFAULT_STATE_APPROVETICKETS } from "../../../utils/enum/defaultParams.enum";
import { ApproveTicketsFilterRequest } from "../../../types/request/ticket.request.type";

const initialState: ApproveTicketsState = {
  isFetching: false,
  data: [],
  error: undefined,
  selectedItem: undefined,
  filterOptions: {
    states: [DEFAULT_STATE_APPROVETICKETS],
  },
  request: undefined,
};

const approveTicketsSlice = createSlice({
  name: "approveTickets",
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.isFetching = true;
    },
    rxSuccessFetchingData: (state, { payload }: PayloadAction<AttendTicket[]>) => {
      state.isFetching = false;
      state.data = payload;
      state.error = undefined;
      if (state.selectedItem) {
        const foundSelected = payload.find((e) => e.nombreUsuario === state.selectedItem!.nombreUsuario);
        if (!foundSelected) {
          state.selectedItem = undefined;
        } else {
          state.selectedItem = foundSelected;
        }
      }
    },
    rxErrorFetchingData: (state, { payload }: PayloadAction<string>) => {
      state.isFetching = false;
      state.data = [];
      state.error = payload;
    },
    rxSetRequest: (state, { payload }: PayloadAction<ApproveTicketsFilterRequest>) => {
      state.request = payload;
    },
    rxSetFilterOptions: (state, { payload }: PayloadAction<FilterOptionsAttendTickets>) => {
      state.filterOptions = payload;
    },
    rxResetFilter: (state) => {
      state.filterOptions = {
        states: [DEFAULT_STATE_APPROVETICKETS],
      };
    },
    rxSetSelectedAttendTicket: (state, { payload }: PayloadAction<AttendTicket>) => {
      if (state.selectedItem) {
        state.selectedItem = state.selectedItem.nombreUsuario === payload.nombreUsuario ? undefined : payload;
      } else {
        state.selectedItem = payload;
      }
    },
  },
});

export const {
  rxErrorFetchingData,
  rxResetFilter,
  rxSetFilterOptions,
  rxSetSelectedAttendTicket,
  rxStartFetching,
  rxSuccessFetchingData,
  rxSetRequest,
} = approveTicketsSlice.actions;
export const approveTicketsSelector = (state: { approveTickets: ApproveTicketsState }) => state.approveTickets;
export default approveTicketsSlice.reducer;
